import { FreeTrialBadgeUsageProps } from './FreeTrialBadge.js';

export const formatFreeTrialBadgeInfo = ({
  platformFeeDollars,
}: {
  platformFeeDollars: null | number;
}): FreeTrialBadgeUsageProps | undefined => {
  const freeTrialBadgeInfo: FreeTrialBadgeUsageProps | undefined =
    platformFeeDollars === null
      ? undefined
      : platformFeeDollars > 0
        ? {
            showNewBadgeIfNotFree: true,
          }
        : {
            showNewBadgeIfNotFree: false,
          };

  return freeTrialBadgeInfo;
};
